import { render, staticRenderFns } from "./donate-button-widget-v2.vue?vue&type=template&id=11dd5209&"
import script from "./donate-button-widget-v2.vue?vue&type=script&lang=js&"
export * from "./donate-button-widget-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports